var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagZh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee1c25;\n      }\n\n      .cls-2 {\n        fill: #ff0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1-2",
    "data-name": "Lag_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lag_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0h900v600H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    className: "cls-2",
    d: "M150,60l52.9,162.8L64.4,122.2h171.2l-138.5,100.6,52.9-162.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-2",
    className: "cls-2",
    d: "M311.7,32.4l-5,56.8-29.4-48.9,52.5,22.3-55.6,12.8s37.5-43,37.5-43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-3",
    className: "cls-2",
    d: "M381.5,99.1l-26.7,50.4-8.1-56.5,39.7,41-56.2-9.8,51.2-25.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-4",
    className: "cls-2",
    d: "M388.2,199.7l-44.9,35.2,15.7-54.9,19.6,53.6-47.3-31.9,57-2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-5",
    className: "cls-2",
    d: "M310.6,241.9l-2.6,57-31.4-47.7,53.4,20.1-55,15.1,35.6-44.6h0v.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagZh);
export default __webpack_public_path__ + "static/media/Flag_ZH.f9608f23a80a78d4775cf0873d57c645.svg";
export { ForwardRef as ReactComponent };